module.exports = "/_next/static/images/f69c23a683afc2a0dd436436cd231406-look-earnings.png.webp";